import { API } from '@/src/api/api'
import { useProductAnalytics } from '@/src/api/data/analytics'
import { queryClient } from '@/src/api/queryClient'
import { queryKeys } from '@/src/api/queryKeys'
import type { CreateIsoMeasureDto } from '@/src/api/types/generated-types'
import { useMutation } from '@tanstack/react-query'

export const useCreateMeasure = () => {
  const { reportEvent } = useProductAnalytics()

  return useMutation({
    mutationFn: async (createMeasure: CreateIsoMeasureDto) => {
      return API.isoMeasures.createOne(createMeasure)
    },
    onSuccess: data => {
      reportEvent('measure_created', { measureId: data?.id })

      queryClient.invalidateQueries({
        queryKey: queryKeys.iso.measures.manyByCompanyId.toKey(),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.iso.measures.manyBacklogByCompanyId.toKey(),
      })
    },
  })
}
